export const BOLLORE_AGENT_ID = "997";
export const OVRSEA_AGENT_ID = "657";
